<div
  class="flex min-w-0"
  [class.min-h-full]="!fixedHeight()"
  [class.min-h-0]="fixedHeight()"
  [class.flex-1]="fixedHeight()"
>
  <div
    class="fixed bottom-0 left-0 top-16 z-[100] transition-all duration-300 ease-in-out"
    [class.w-64]="sidebarExpanded()"
    [class.w-20]="!sidebarExpanded()"
  >
    <mw-sidebar-menu
      [menuItems]="menuItems()"
      [isExpanded]="sidebarExpanded()"
      (toggleExpanded)="toggleSidebar()"
    />
  </div>

  <div
    class="min-w-0 flex-1 transition-all duration-300 ease-in-out"
    [class.min-h-full]="!fixedHeight()"
    [class.flex]="fixedHeight()"
    [class.min-h-0]="fixedHeight()"
    [class.flex-col]="fixedHeight()"
    [class.pl-64]="sidebarExpanded()"
    [class.pl-20]="!sidebarExpanded()"
  >
    <div
      class="px-4 pb-4 pt-4 max-sm:pb-24 lg:px-6"
      [class.flex]="fixedHeight()"
      [class.min-h-0]="fixedHeight()"
      [class.flex-1]="fixedHeight()"
      [class.flex-col]="fixedHeight()"
    >
      <ng-content />
    </div>
  </div>
</div>
